//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GridView from '@/components/GridView'
import GridViewValue from '@/components/GridViewValue'
import GridViewLabel from '@/components/GridViewLabel'
import mixin from './mixin'

export default {
  name: 'FixedWireless',

  mixins: [mixin],

  components: {
    GridViewLabel,
    GridViewValue,
    GridView
  },

  data() {
    return {
      internetReference: ['NET', 'DCI', 'SFI'],
      ethernetReference: ['VPE', 'DCV', 'SFV']
    }
  },

  computed: {
    isInternet() {
      const productReference = this.productReference
      return this.internetReference.includes(productReference)
    },

    isEthernet() {
      const productReference = this.productReference
      return this.ethernetReference.includes(productReference)
    },

    getOrderFormDownload() {
      return false
    }
  }
}
